/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wf_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How is this different from the word counter?`)
};

const es_wf_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿En qué se diferencia esto del contador de palabras?`)
};

const de_wf_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie unterscheidet sich das vom Wortzähler?`)
};

const nl_wf_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe verschilt dit van de woordteller?`)
};

const fr_wf_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En quoi est-ce différent du compteur de mots ?`)
};

const it_wf_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In che modo questo è diverso dal contatore di parole?`)
};

const pt_br2_wf_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como isso é diferente do contador de palavras?`)
};

const pt_wf_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a diferença entre isto e o contador de palavras?`)
};

const ja_wf_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`これは単語カウンターとどのように異なっていますか？`)
};

const zh_wf_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这个工具和单词计数器有什么区别？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wf_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wf_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wf_faq1_q", locale)
	if (locale === "en") return en_wf_faq1_q(inputs)
	if (locale === "es") return es_wf_faq1_q(inputs)
	if (locale === "de") return de_wf_faq1_q(inputs)
	if (locale === "nl") return nl_wf_faq1_q(inputs)
	if (locale === "fr") return fr_wf_faq1_q(inputs)
	if (locale === "it") return it_wf_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_wf_faq1_q(inputs)
	if (locale === "pt") return pt_wf_faq1_q(inputs)
	if (locale === "ja") return ja_wf_faq1_q(inputs)
	return zh_wf_faq1_q(inputs)
};